// Page removed per request
export default function AdminExchanges() { return null; }